<!--<template>-->
<!--    <div>-->
<!--        &lt;!&ndash; Header &ndash;&gt;-->
<!--        <h2 class="text-gray-600 text-lg font-medium mb-3">ACCOUNT DETAIL</h2>-->

<!--        &lt;!&ndash; Account Details &ndash;&gt;-->
<!--        <div class="bg-white px-4 py-3 rounded-lg shadow-md">-->
<!--            &lt;!&ndash; Account number &ndash;&gt;-->
<!--            <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">-->
<!--                <span class="text-gray-600">Account number</span>-->
<!--                <span class="text-gray-800 font-medium">0108855/001.000.978</span>-->
<!--            </div>-->

<!--            &lt;!&ndash; Account name &ndash;&gt;-->
<!--            <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">-->
<!--                <span class="text-gray-600">Account name</span>-->
<!--                <span class="text-gray-800 font-medium">Current Account EUR</span>-->
<!--            </div>-->

<!--            &lt;!&ndash; NIB &ndash;&gt;-->
<!--            <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">-->
<!--                <span class="text-gray-600">NIB (Bank Identification Number)</span>-->
<!--                <span class="text-gray-800 font-medium">0063 0001 010885500010 02</span>-->
<!--            </div>-->

<!--            &lt;!&ndash; IBAN &ndash;&gt;-->
<!--            <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">-->
<!--                <span class="text-gray-600">IBAN</span>-->
<!--                <div class="flex flex-col items-end space-x-3">-->
<!--                    <span class="text-gray-800 font-medium">PT50 0063 0001 010885500010 02</span>-->
<!--                    <button-->
<!--                        @click="copyToClipboard('PT50 0063 0001 010885500010 02')"-->
<!--                        class="text-primary text-sm font-medium transition-colors duration-200"-->
<!--                    >-->
<!--                        <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">-->
<!--                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>-->
<!--                        </svg>-->
<!--                        Copy-->
<!--                    </button>-->
<!--                </div>-->
<!--            </div>-->

<!--            &lt;!&ndash; SWIFT/BIC &ndash;&gt;-->
<!--            <div class="flex justify-between items-center px-2 py-3">-->
<!--                <span class="text-gray-600">SWIFT/BIC</span>-->
<!--                <span class="text-gray-800 font-medium">BNFIPTPL</span>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</template>-->

<!--<script setup>-->

<!--// Copy to clipboard functionality-->
<!--const copyToClipboard = async (text) => {-->
<!--    try {-->
<!--        await navigator.clipboard.writeText(text)-->
<!--        // You can add a toast notification here if needed-->
<!--        console.log('IBAN copied to clipboard:', text)-->
<!--    } catch (err) {-->
<!--        console.error('Failed to copy text: ', err)-->
<!--        // Fallback for older browsers-->
<!--        const textArea = document.createElement('textarea')-->
<!--        textArea.value = text-->
<!--        document.body.appendChild(textArea)-->
<!--        textArea.select()-->
<!--        document.execCommand('copy')-->
<!--        document.body.removeChild(textArea)-->
<!--    }-->
<!--}-->
<!--</script>-->



<template>
  <div>
    <!-- Header -->
    <h2 class="text-gray-600 text-lg font-medium mb-3">ACCOUNT DETAIL</h2>

    <!-- Account Details -->
    <div class="bg-white px-4 py-3 rounded-lg shadow-md">
      <!-- Account number -->
      <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">
        <span class="text-gray-600">Account number</span>
        <span class="text-gray-800 font-medium">{{ props.account.account_number }}</span>
      </div>

      <!-- Account name -->
      <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">
        <span class="text-gray-600">Account name</span>
        <span class="text-gray-800 font-medium">{{ props.account.account_name }}</span>
      </div>

      <!-- NIB -->
      <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">
        <span class="text-gray-600">NIB (Bank Identification Number)</span>
        <span class="text-gray-800 font-medium">{{ account.nib ?? '-' }}</span>
      </div>

      <!-- IBAN -->
      <div class="flex justify-between items-center px-2 py-3 border-b border-gray-200">
        <span class="text-gray-600">IBAN</span>
        <div class="flex flex-col items-end space-x-3">
          <span class="text-gray-800 font-medium">{{ account.iban ?? '-' }}</span>
          <button
              @click="copyToClipboard(account.iban)"
              class="text-primary text-sm font-medium transition-colors duration-200"
              v-if="account.iban"
          >
            <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"></path>
            </svg>
            Copy
          </button>
        </div>
      </div>

      <!-- SWIFT/BIC -->
      <div class="flex justify-between items-center px-2 py-3">
        <span class="text-gray-600">SWIFT/BIC</span>
        <span class="text-gray-800 font-medium">{{ account.swift ?? '-' }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'

const props = defineProps({
  account: {
    type: Object,
    required: true
  }
})


// Copy to clipboard functionality
const copyToClipboard = async (text) => {
  if (!text) return
  try {
    await navigator.clipboard.writeText(text)
    console.log('Copied to clipboard:', text)
  } catch (err) {
    console.error('Failed to copy text: ', err)
    const textArea = document.createElement('textarea')
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
  }
}
</script>
